import { Link } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { IMAGES, WHATSAPP_URL, PHOTO_LABEL } from "@/lib/constants";
import { track, EVENTS } from "@/lib/analytics";
import { useEnquiry } from "@/context/EnquiryContext";
import { Reveal } from "@/components/Reveal";

const TRUST_POINTS = ["Actual-lot samples", "GST invoice", "Grade-wise supply", "Hyderabad dispatch"];

export const Hero = () => {
  const { openEnquiry } = useEnquiry();

  return (
    <section id="top" className="relative bg-spice-green text-white pt-14 pb-16 sm:pt-20 sm:pb-20 px-4 sm:px-6 overflow-hidden" data-testid="hero-section">
      <div className="absolute inset-0 pointer-events-none" aria-hidden="true">
        <img
          src={IMAGES.hero.url}
          alt=""
          width={IMAGES.hero.width}
          height={IMAGES.hero.height}
          className="w-full h-full object-cover opacity-20"
          loading="eager"
          fetchPriority="high"
        />
        <div className="absolute inset-0 bg-spice-green/75" />
      </div>

      <div className="relative max-w-4xl mx-auto text-center space-y-6">
        <Reveal className="space-y-6">
          <div className="inline-flex items-center gap-2 px-3 py-1 bg-spice-green-light/60 border border-spice-gold/40 rounded-full text-xs text-[#E6D5A7]">
            <span className="w-2 h-2 rounded-full bg-spice-gold" aria-hidden="true"></span>
            <span>Hyderabad &amp; Telangana wholesale supply</span>
          </div>

          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight leading-[1.15]" data-testid="hero-headline">
            Wholesale Cardamom and Whole Spices for Commercial Buyers
          </h1>

          <p className="text-base sm:text-lg text-spice-mist leading-relaxed max-w-2xl mx-auto" data-testid="hero-subtext">
            Lot-specific grades, transparent quotations and dependable supply from Hyderabad to buyers across
            Telangana and other commercially feasible locations.
          </p>

          <div className="flex flex-col sm:flex-row items-stretch sm:items-center justify-center gap-3 pt-1">
            <button
              type="button"
              onClick={() => openEnquiry({ source: "hero" })}
              data-testid="hero-quote-button"
              className="px-7 py-3.5 bg-spice-gold text-spice-green-dark font-bold text-sm rounded-[9px] hover:bg-spice-gold-light transition-colors shadow-md"
            >
              Request Current Quote
            </button>
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Enquire on WhatsApp (opens WhatsApp in a new tab)"
              onClick={() => track(EVENTS.whatsappClick, { source: "hero" })}
              data-testid="hero-whatsapp-button"
              className="inline-flex items-center justify-center gap-2 px-7 py-3.5 bg-white/10 border border-white/40 text-white font-semibold text-sm rounded-[9px] hover:bg-white/20 transition-colors"
            >
              <MessageCircle className="w-4 h-4" aria-hidden="true" />
              Enquire on WhatsApp
            </a>
          </div>

          <div>
            <Link
              to="/products"
              data-testid="hero-products-link"
              className="inline-block text-sm text-[#E6D5A7] underline underline-offset-4 hover:text-white transition-colors"
            >
              View Products and Grades
            </Link>
          </div>

          <ul className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 pt-2 text-[11px] sm:text-xs text-spice-mist max-w-full" data-testid="hero-trust-line">
            {TRUST_POINTS.map((point, i) => (
              <li key={point} className="flex items-center gap-3">
                {i > 0 && <span className="hidden sm:inline text-white/30" aria-hidden="true">|</span>}
                <span>{point}</span>
              </li>
            ))}
          </ul>

          <p className="text-[11px] text-spice-sage/80 pt-1">Background image: {PHOTO_LABEL.toLowerCase()}.</p>
        </Reveal>
      </div>
    </section>
  );
};
